// eslint-disable-next-line import/no-anonymous-default-export
export default {
    common: {
        sendSlackNotification: (channel) => `/utils/sendCustomSlackMessage?channel=${channel}`,
    },
    company: {
        getCompanyByStub: (stub) => `/company/company-by-stub/${stub}`,
        getCompanyById: (id) => `/company/${id}`,
        getDefaultCompany: () => '/company/default',
    },
    upload: {
        singleImage: (id) => `/image/${id}`,
        addImage: () => '/image/',
        imageType: () => '/imagetype/0/0',
        manageAvatar: (id) => `/user/${id}/avatar`,
        userAvatar: () => '/user/avatar',
    },
    user: {
        validateToken: () => '/authentication/validateToken',
        createUser: () => '/user/register',
        redeemInvite: () => '/user/invite',
        recoverPassword: (email) => `/user/recoverPassword/${email}`,
        userById: (userId) => `/user/${userId}`,
        userByToken: () => '/user/',
    },
};
